<template id="placeTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <div class="main-div" :class="formState.invalidShake?'invalid':''">
      <small
        class="--centered-block"
        v-if="(newPlace==null)"
      >Select a Location from the list to edit. Press the "Add New" Button to add a new location</small>
      <div class="form-group col-12 col-sm-12" v-if="newPlace==null">
        <label class="pl-0 col-12 col-sm-12" for="places">All Locations</label>
        <div class="p-0 mb-4 col-12 col-sm-12">
          <input
            class="form-control"
            type="text"
            maxlength="200"
            placeholder="Search All Locations"
            v-model="placesSearch"
          />
        </div>
        <b-form-select
          :disabled="formState.loading"
          class="col-12 col-sm-12"
          style="font-size:16px;"
          v-model="selectedPlaceId"
          :options="filteredPlaces"
          :select-size="+10"
        ></b-form-select>
      </div>

      <div
        v-if="errors.length && formState.attempted && (!formState.loading)"
        class="col-12 col-sm-12"
      >
        <b class="w-100">Please correct the following error(s):</b>
        <ul>
          <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>

      <form class="place-form">
        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newPlace==null)&&selectedPlaceData"
        >
          <legend>Existing Location's Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name">Name</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedPlaceData.name"
                id="name"
                placeholder="Name"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name_en">Name (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedPlaceData.name_en"
                id="name_en"
                placeholder="Name (EN)"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="delivery_price">Delivery Price</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="number"
                v-model="selectedPlaceData.delivery_price"
                id="delivery_price"
                placeholder="ex. 50"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="man_price">Size Man's Price</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="number"
                v-model="selectedPlaceData.man_price"
                id="man_price"
                placeholder="ex. 50"
              />
            </div>
            <div class="form-group col-12 col-sm-12" v-if="newPlace==null">
              <label class="pl-0 col-12 col-sm-12" for="places">Country</label>
              <b-form-select
                :disabled="formState.loading"
                class="modified-dropdown col-12 col-sm-12"
                style="font-size:16px;"
                v-model="selectedPlaceData.country_id"
                :options="topLevelPlaces"
                v-on:change="changePlace"
              ></b-form-select>
            </div>
          </div>
        </fieldset>
        <div class="alert alert-danger" v-if="(newPlace==null)&&selectedPlaceData&&!selectedPlaceData.country_id">
          If you will not deliver to this country any more, please make sure that the related governorates are removed.
        </div>
        <div class="form-group col-12 col-sm-12">
          <div class="mb-2 col-12 col-sm-6" v-if="(newPlace==null)&&selectedPlaceData">
            <button
              type="button"
              v-on:click="deletePlace()"
              class="btn btn-danger"
              :disabled="formState.loading"
            >Delete Selected Location</button>
          </div>
          <div class="mb-2 col-12 col-sm-6" v-if="(newPlace==null)&&selectedPlaceData">
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="commitChanges()"
              class="btn btn-info"
            >Confirm Changes</button>
          </div>
        </div>

        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newPlace!=null)"
        >
          <legend>New Location's Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-12" v-if="newPlace!=null">
              <label class="p-0 col-12 col-sm-12" for="places">Country (<span class="text-info">إذا كنت تريد إضافة مدينة, اترك هذا الاختيار فارغاً</span>)</label>
              <b-form-select
                :disabled="formState.loading"
                class="modified-dropdown col-12 col-sm-12"
                style="font-size:16px;"
                v-model="newPlace.country_id"
                :options="topLevelPlaces"
                v-on:change="changePlace"
              ></b-form-select>
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name">Name</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newPlace.name"
                id="name"
                placeholder="Name"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name_en">Name (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newPlace.name_en"
                id="name_en"
                placeholder="Name (EN)"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="delivery_price">Delivery Price</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="number"
                v-model="newPlace.delivery_price"
                id="delivery_price"
                placeholder="ex. 50"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="man_price">Size Man's Price</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="number"
                v-model="newPlace.man_price"
                id="man_price"
                placeholder="ex. 50"
              />
            </div>
          </div>
        </fieldset>

        <div class="col-12 col-sm-12" v-if="newPlace!=null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="saveNewPlace()"
            class="btn btn-info"
          >Save New Location</button>
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="cancelNewPlace()"
            class="btn btn-danger"
          >Cancel New Location</button>
        </div>

        <div class="col-12 col-sm-12" v-if="newPlace==null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="addNewPlace()"
            class="m-0 btn btn-primary"
          >Add New Location</button>
        </div>
      </form>
    </div>
  </div>
</template>



<!-- place Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}
.main-div {
  padding: 50px;
  width: 80%;
  .--centered-block {
    margin: 0 auto;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }
}
//  0.82s
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "placesCRUD",
  data() {
    return {
      newPlace: null, // If add place button is pressed, this will be an object of the new place.
      placesSearch: "", // We search All places Depending on this.
      selectedPlaceId: null, // Specifies The Id of the selected location in the database
      selectedPlaceData: null, // Data is fetched from the backend using selectedPlaceId
      places: [{ value: null, text: "Please select a location to edit" }], // All places (Fetched When component is mounted)
      filteredPlaces: [{ value: null, text: "Please select a location to edit" }], // All places Filtered Using placesSearch
      topLevelPlaces: [{ value: null, text: "Please select a location to edit" }], // All places Filtered Using placesSearch
      rawPlacesData: [],
      errors: [], // Form's errors
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false
      } // Object Determining the Form's state
    };
  },
  watch: {
    // Computes the Filtered Array out of places fetched from backend.
    placesSearch: function() {
      this.filteredPlaces = this.places.filter(str => {
        return this.placesSearch == ""
          ? true
          : str.text.toLowerCase().includes(this.placesSearch.toLowerCase());
      });
      if (this.filteredPlaces.length < 1)
        this.filteredPlaces = [{ value: null, text: "No such result" }];
    },
    // When selectedPlaceId is changed, the place's Data is fetched from the backend, If null is selected, the form is reset.
    selectedPlaceId: function() {
      if (this.selectedPlaceId) {
        this.fetchAllplaceData(this.selectedPlaceId);
      } else {
        this.partiallyResetForm();
      }
    },
    newPlace: function() {
      this.checkForm();
    },
    selectedPlaceData: function() {
      this.checkForm();
    },
    "newPlace.country_id": function(){
      if(this.newPlace && this.newPlace.country_id){
        let theCountryData = this.rawPlacesData.find((i)=>{return i.id == this.newPlace.country_id});
        this.newPlace.man_price = theCountryData.man_price;
        this.newPlace.delivery_price = theCountryData.delivery_price;
      }
    }
  },
  mounted() {
    this.fetchAllplaces();
  },
  methods: {
    // Partially resets the form
    partiallyResetForm: function() {
      this.cancelNewPlace();
      this.selectedPlaceData = null;
      this.selectedPlaceId = null;
      this.errors = [];
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false
      };
    },
    changePlace: function() {
      /* 
       * Check if the form has any valid values; 
       * When selecting area with Discount price, 
       * it gets added and as long as it's above 0, 
       * it should be accepted
      */
      this.checkForm();
    },
    checkForm: function() {
      this.errors = [];
      if (this.newPlace) {
        if (!this.newPlace.name) this.errors.push("Location's Name is required");
        if (!this.newPlace.name_en)
          this.errors.push("Location's Name (EN) is required");
        if (!this.newPlace.delivery_price || this.newPlace.delivery_price < 0)
          this.errors.push("Delivery price is required. Minimum is 0");
      } else if (this.selectedPlaceData) {
        if (!this.selectedPlaceData.name)
          this.errors.push("Location's Name is required");
        if (!this.selectedPlaceData.name_en)
          this.errors.push("Location's Name (EN) is required");
        if (
          !this.selectedPlaceData.delivery_price ||
          this.selectedPlaceData.delivery_price < 0
        )
          this.errors.push("Delivery price is required. Minimum is 0");
      }
    },
    fetchAllplaces() {
      this.formState.loading = true;
      return axios
        .post(`${herokuUrl}/dashboard/getAllplaces`, null, {
          headers: {
            Authorization: getCookie("user")
          }
        })
        .then(res => {
          this.places = [
            { value: null, text: "Please select a location to edit" }
          ];
          this.topLevelPlaces = [
            { value: null, text: "Please select a location to edit" }
          ];
          res.data.places.forEach(element => {
            this.places.push({
              text: element.name,
              value: element.id
            });
            if (element.country_id == null)
              this.topLevelPlaces.push({
                text: element.name,
                value: element.id
              });
          });
          this.filteredPlaces = [...this.places];
          this.rawPlacesData = [...res.data.places];
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Locations fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    fetchAllplaceData(id) {
      this.formState.loading = true;
      return axios
        .post(
          `${herokuUrl}/dashboard/getAllPlaceData`,
          { id },
          {
            headers: {
              Authorization: getCookie("user")
            }
          }
        )
        .then(res => {
          this.partiallyResetForm();
          this.selectedPlaceData = { ...res.data.placeData };
          this.selectedPlaceId = this.selectedPlaceData.id;
          if (this.selectedPlaceData.country_id) {
            let countryData = this.rawPlacesData.find(rawPlace => {
              return rawPlace.id == this.selectedPlaceData.country_id;
            });

            this.selectedPlaceData.delivery_price =
              this.selectedPlaceData.delivery_price == null ||
              this.selectedPlaceData.delivery_price == undefined
                ? countryData.delivery_price
                : this.selectedPlaceData.delivery_price;

            this.selectedPlaceData.man_price =
              this.selectedPlaceData.man_price == null ||
              this.selectedPlaceData.man_price == undefined
                ? countryData.man_price
                : this.selectedPlaceData.man_price;
          }
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Locations fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    deletePlace() {
      if (confirm("Please confirm you want to DELETE the selected location")) {
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/dashboard/deletePlace`,
            {
              id: this.selectedPlaceData.id
            },
            {
              headers: {
                Authorization: getCookie("user")
              }
            }
          )
          .then(() => {
            alert("Location was deleted successfully");
            this.partiallyResetForm();
            this.fetchAllplaces();
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected location " +
                  err.response.data.message
              );
            }
          });
      }
    },
    commitChanges() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected location with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .post(`${herokuUrl}/dashboard/editPlace`, this.selectedPlaceData, {
              headers: {
                Authorization: getCookie("user")
              }
            })
            .then(() => {
              alert("Location was Edited successfully");
              this.partiallyResetForm();
              this.fetchAllplaces();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected location " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
    addNewPlace() {
      this.newPlace = {
      };
    },
    cancelNewPlace() {
      this.newPlace = null;
    },
    saveNewPlace() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (confirm("Please confirm you want to Add a new location")) {
          this.formState.loading = true;
          return axios
            .post(
              `${herokuUrl}/dashboard/addNewPlace`,
              {
                ...this.newPlace
              },
              {
                headers: {
                  Authorization: getCookie("user")
                }
              }
            )
            .then(() => {
              alert("Location was Added successfully");
              this.partiallyResetForm();
              this.fetchAllplaces();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem adding the new place " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>
